export default __webpack_public_path__ + "static/media/208.0245a278.jpg";